import { hideBackButton, onBackButtonClick, showBackButton } from '@/shared/telegram';

// SDK show/hide are global side effects, so we can't let each call site
// drive them directly: an inactive owner's hide would clobber an active
// owner's show. Owners register here; the top of the stack wins.

interface Owner {
  id: number;
  onBack: () => void;
  priority: number;
}

const owners: Owner[] = [];
let nextOwnerId = 1;
let detachClick: (() => void) | undefined;
let activeOwnerId: number | undefined;

const applyTopOwner = (): void => {
  const top = owners[owners.length - 1];

  if (!top) {
    if (detachClick) {
      detachClick();
      detachClick = undefined;
    }
    activeOwnerId = undefined;
    hideBackButton();
    return;
  }

  if (activeOwnerId === top.id) {
    return;
  }

  if (detachClick) {
    detachClick();
    detachClick = undefined;
  }

  showBackButton();
  detachClick = onBackButtonClick(() => {
    top.onBack();
  });
  activeOwnerId = top.id;
};

export const acquireBackButton = (onBack: () => void, priority = 0): number => {
  const id = nextOwnerId++;
  owners.push({ id, onBack, priority });
  owners.sort((a, b) => a.priority - b.priority || a.id - b.id);
  applyTopOwner();
  return id;
};

export const updateBackButtonHandler = (id: number, onBack: () => void): void => {
  const owner = owners.find((o) => o.id === id);
  if (!owner) return;
  owner.onBack = onBack;
};

export const releaseBackButton = (id: number): void => {
  const index = owners.findIndex((o) => o.id === id);
  if (index === -1) return;
  owners.splice(index, 1);
  applyTopOwner();
};

export const __resetBackButtonStackForTests = (): void => {
  owners.length = 0;
  if (detachClick) {
    detachClick();
    detachClick = undefined;
  }
  activeOwnerId = undefined;
  nextOwnerId = 1;
};
